const styles: any = (theme: any) => ({
  root: {
    width: '100%',
    marginRight: 0,
    marginBottom: '20px',
    gridTemplateRows: '200px 1fr',
    '@media (min-width:576px)': {
      width: '250px',
      marginRight: '20px'
    },
    '@media (min-width: 768px)': {
      width: '220px'
    },
    '@media (min-width:992px)': {
      width: '215px'
    }
  },

  primary: {
    fontSize: '0.7143rem',
    color: theme.primary
  },

  secondary: {
    fontSize: '0.7143rem',
    color: '#b5b5b5'
  },

  content: {
    height: '100%'
  },

  card: {
    height: '100%'
  },

  actionArea: {
    height: '100%'
  },

  label: {
    position: 'absolute',
    top: 10,
    right: 10,
    background: theme.nav,
    color: theme.navText || '#1C2541',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    padding: 5,
    borderRadius: 4
  }
});
export default styles;
